import JobsCompletedSection from "./JobsCompletedSection";

export default JobsCompletedSection;
